export default {
  title: "Mudanças nos quadros de horários das linhas nos feriados do Natal e Ano Novo",
  resume: "Durante as vésperas (24 e 31) e os feriados (25/12 e 01/01), os quadros de horários das linhas mudam.",
  img: "/news/neobus-44115.jpg",
  publishDate: "2025-11-30T00:00:00.000-03:00",
  content: [
    "<>Nesses dias, geralmente até as 12 ou 14 horas, as linhas operam no quadro de horários do dia corrente e depois no quadro de horários de feriado (geralmente o mesmo de domingo). Para evitar qualquer transtorno causado por informações incorretas, optamos, nas vésperas de feriados, definir todas as linhas com o horário de partida de domingo e/ou feriados. Nos dias (25 e 01/01) os horários de partidas para todas as linhas também serão de domingo e/ou feriados. <Link to={\"/lines\"}>Consulte os horários das linhas aqui.</Link>",
  ],
};
